import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { AnyAction } from 'redux';
import { App, TaasInfo } from '@ps20-frontend/frontend-models';
import { CommonInsuranceData, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';

export const unfTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
  state: IAppState,
): TaasInfo {
  sectionState = taasInfoReducer(sectionState, action, App.UNF, state?.angebotsId);
  if (action.type === GlobalActions.COMMON_INSURANCE_DATA_RECEIVED) {
    const actionPayload: CommonInsuranceData = action.payload;
    return {
      ...sectionState,
      role: actionPayload.role,
    };
  }
  return sectionState;
};
